import { accessToken } from 'ducks/entities/schema'

export const thirdPartyAccessTokensApiV0ResponseSchema = [accessToken]
